import * as React from 'react';

import { ErrorBoundary, ViewLarge, ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { AvailabilityWizard } from 'components/infosite/rooms-and-rates/availability-wizard';
import { ExposedSearchForm } from 'components/infosite/rooms-and-rates/exposed-search-form';
import { SharedUiDatelessForm, SharedUiDatelessFormMobile } from 'components/infosite/shared-ui/form/shared-ui-forms';
import { StickyWizardWrapper } from 'components/infosite/rooms-and-rates/sticky-wizard-wrapper';

interface SearchWizardComposerProps {
  currentHotel?: CurrentHotelStore;
  searchFormRef: any;
  RefTarget: any;
  navigateToHsr?: any;
  isMultiItem?: any;
  soldOut?: any;
  onUpdateResults?: any;
  alternateDatesForMeta: any;
  onUpdateResultsAvailabilityWizard: any;
}

export const SearchWizardComposer: React.FunctionComponent<SearchWizardComposerProps> = ({
  currentHotel,
  searchFormRef,
  RefTarget,
  navigateToHsr,
  isMultiItem,
  soldOut,
  onUpdateResults,
  alternateDatesForMeta,
  onUpdateResultsAvailabilityWizard,
}) => {
  const { defaultedDates, loadingOffers, offers } = currentHotel;
  const { alternateDates, rooms } = offers || {};

  const availabilityWizardProps = {
    useProgressIndicator: false,
    currentHotelOnly: true,
    loadingOffers,
    rooms,
    onUpdateResults: onUpdateResultsAvailabilityWizard,
    metaSavingsOption: alternateDatesForMeta,
    alternateDates,
    soldOut,
    isMultiItem,
  };

  if (isMultiItem) {
    return null;
  }

  if (defaultedDates) {
    return (
      <>
        <ErrorBoundary label="hotel.information.rooms.exposedSearchForm">
          <div className="all-y-padding-two" data-stid="section-hotel-search" ref={searchFormRef}>
            <Viewport>
              <ViewSmall>
                <RefTarget name="wizard" className="uitk-cell">
                  <SharedUiDatelessFormMobile onSubmit={navigateToHsr} />
                </RefTarget>
              </ViewSmall>
              <ViewMedium>
                <StickyWizardWrapper>
                  <SharedUiDatelessForm onSubmit={navigateToHsr} />
                </StickyWizardWrapper>
              </ViewMedium>
            </Viewport>
          </div>
        </ErrorBoundary>
      </>
    );
  }

  return (
    <Viewport>
      <ViewSmall>
        <AvailabilityWizard {...availabilityWizardProps} />
      </ViewSmall>
      <ViewLarge>
        <React.Fragment>
          <ErrorBoundary label="hotel.information.rooms.availabilityWizard">
            <ExposedSearchForm onUpdateResults={onUpdateResults} metaSavingsOption={alternateDatesForMeta} />
          </ErrorBoundary>
        </React.Fragment>
      </ViewLarge>
    </Viewport>
  );
};

SearchWizardComposer.displayName = 'SearchWizardComposer';
